import { EVENT_TABS, EVENT_TYPES } from 'utils/constants';

import c from './constants';

const getTypeColor = (type: EVENT_TYPES, accessorType?: EVENT_TABS) => {
  if (accessorType === EVENT_TABS.MONTH) {
    switch (type) {
      case c.EVENT_TYPES.BOOKING:
        return 'bg-[#7740F4]';
      case c.EVENT_TYPES.CALL:
        return 'bg-[#244EE0]';
      case c.EVENT_TYPES.VIDEO:
        return 'bg-[#F200B1]';
      default:
        return 'bg-[#20BA49]';
    }
  } else {
    switch (type) {
      case c.EVENT_TYPES.BOOKING:
        return 'border-[#7740F4]';
      case c.EVENT_TYPES.CALL:
        return 'border-[#244EE0]';
      case c.EVENT_TYPES.VIDEO:
        return 'border-[#F200B1]';
      default:
        return 'border-[#20BA49]';
    }
  }
};

export default getTypeColor;
